import { CheckCircle } from 'lucide-react'
import Link from 'next/link'

import { Button } from '@/components/ui/button'

const SubmitSuccess = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <CheckCircle className="mb-6 h-16 w-16 text-success" />
      <h2 className="mb-4 text-xl font-bold">お問い合わせを受け付けました</h2>
      <p className="mb-8 text-muted-foreground">
        お問い合わせをいただきありがとうございます。
        <br />
        担当者より順次ご連絡いたしますので、しばらくお待ちください。
      </p>
      <Link href="/">
        <Button variant="primary">トップページに戻る</Button>
      </Link>
    </div>
  )
}

export default SubmitSuccess
